export default __webpack_public_path__ + "static/media/slide2.5e3e25b1.png";